import { Link } from 'react-router-dom';

function GrilleRealisations({ realisations }) {
    const len = realisations.length;

    const gridClass =
        len === 1 ? 'flex justify-center' :
        len === 2 ? 'grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-center max-w-3xl mx-auto' :
                    'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8';

    const cardClass =
        len === 1 ? 'w-full max-w-[480px]' :
        len === 2 ? 'w-full' :
                    'w-full';

    return (
        <div className={`${gridClass} mb-14`}>
            {realisations.map((r, i) => (
                <div
                    key={i}
                    className={`flex flex-col bg-white dark:bg-bleu-gris rounded-[12px] shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 ${cardClass}`}
                >
                    {/* Image */}
                    <div className="h-[220px] w-full overflow-hidden">
                        {r.image && (
                            <img
                                src={r.image}
                                alt={r.titre}
                                className="w-full h-full object-cover"
                            />
                        )}
                    </div>

                    {/* Contenu */}
                    <div className="flex flex-col flex-1 p-6 gap-4">
                        <span className="text-bleu-je text-[13px] font-bold uppercase tracking-widest">
                            {r.tag}
                        </span>
                        <h3 className="text-gris-sombre dark:text-blanc-sombre font-bold text-[18px] leading-snug">
                            {r.titre}
                        </h3>
                        <p className="text-gris-sombre dark:text-gray-300 text-[15px] leading-relaxed flex-1">
                            {r.description}
                        </p>
                        {r.client && (
                            <div className="flex items-center gap-3 pt-4 border-t border-gray-100 dark:border-gray-700 mt-auto">
                                {r.clientLogo && (
                                    <img src={r.clientLogo} alt={r.client} className="h-8 w-auto object-contain" />
                                )}
                                <span className="text-gris-sombre dark:text-gray-300 text-[14px] font-semibold">
                                    {r.client}
                                </span>
                                {r.clientUrl && (
                                    <a href={r.clientUrl} target="_blank" rel="noreferrer"
                                        className="ml-auto text-bleu-je text-[13px] hover:underline">
                                        {r.clientUrl}
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

function DetailService({ titre, categorie, image, description, etapes, realisations }) {
    return (
        <div>
            {/* Bannière */}
            <div className="relative h-[280px] w-full overflow-hidden bg-gray-100 dark:bg-bleu-gris">
                {image && (
                    <img
                        src={image}
                        alt={titre}
                        className="w-full h-full object-cover opacity-30 dark:opacity-20"
                    />
                )}
                <div className="absolute inset-0 flex flex-col justify-center items-center px-6 text-center space-y-2">
                    <span className="text-bleu-je text-sm font-semibold uppercase tracking-widest dark:text-bleu-sombre">
                        {categorie}
                    </span>
                    <h1 className="font-comme font-bold text-[32px] md:text-[46px] leading-tight text-gris-sombre dark:text-blanc-sombre max-w-3xl">
                        {titre}
                    </h1>
                </div>
            </div>

            {/* Corps */}
            <div className="bg-white dark:bg-fond-sombre">
                <div className="max-w-5xl mx-auto px-6 py-14">

                    {/* Description */}
                    <p className="text-gris-sombre dark:text-gray-300 text-[18px] leading-relaxed text-center mx-auto mb-16 max-w-3xl">
                        {description}
                    </p>

                    {/* Déroulement de l'étude */}
                    {etapes && etapes.length > 0 && (
                        <div className="mb-16">
                            <h2 className="text-gris-sombre dark:text-blanc-sombre text-[28px] font-semibold text-center mb-10">
                                Déroulement de <span className="text-bleu-je">l'étude</span>
                            </h2>
                            <div className="relative">
                                <div className="absolute left-[28px] top-0 bottom-0 w-[2px] bg-bleu-je opacity-20 hidden md:block" />
                                <div className="flex flex-col gap-8">
                                    {etapes.map((etape) => (
                                        <div key={etape.numero} className="flex gap-6 items-start">
                                            <div className="flex-shrink-0 w-14 h-14 rounded-full bg-bleu-je flex items-center justify-center text-white font-bold text-xl shadow-md z-10">
                                                {etape.numero}
                                            </div>
                                            <div className="flex-1 bg-gray-50 dark:bg-bleu-gris rounded-[8px] p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                                                <h3 className="text-bleu-je dark:text-bleu-sombre font-bold text-[17px] mb-3">
                                                    {etape.titre}
                                                </h3>
                                                <p className="text-gris-sombre dark:text-gray-300 text-[15px] leading-relaxed">
                                                    {etape.texte}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Réalisations */}
                    {realisations && realisations.length > 0 && (
                        <>
                            <h2 className="text-gris-sombre dark:text-blanc-sombre text-[28px] font-semibold text-center mb-10">
                                Nos <span className="text-bleu-je">Réalisations</span>
                            </h2>
                            <GrilleRealisations realisations={realisations} />
                        </>
                    )}

                    {/* CTA retour */}
                    <div className="flex justify-center mt-4">
                        <Link
                            to="/services"
                            className="px-6 py-3 border-2 border-bleu-je text-bleu-je font-semibold rounded-[4px] hover:bg-bleu-je hover:text-white transition-colors duration-200"
                        >
                            ← Voir tous nos services
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default DetailService;

